// extracted by mini-css-extract-plugin
export default {"Banner":"Banner_Banner__EAHvg","Contents":"Banner_Contents__YmwKc","Text":"Banner_Text__C0mNV","TextHeader":"Banner_TextHeader__sGRMG"};